import { useEffect, useId } from 'react';
// @ts-expect-error
import Aliplayer from 'aliyun-aliplayer';
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css';

export enum ECryptoType {
  None = 'None',
  HLS = 'HLS',
  Aliyun = 'Aliyun',
}
export interface AliPlayerProps {
  videoId?: string;
  playAuth?: string;
  url?: string;
  cryptoType?: ECryptoType;
  /** 隐藏全屏按钮并禁用双击全屏 */
  disableFullscreen?: boolean;
  autoplay?: boolean;
  playerId?: string;
}

export const AliPlayer: React.FC<AliPlayerProps> = ({
  videoId,
  playAuth,
  url,
  cryptoType = ECryptoType.Aliyun,
  disableFullscreen = false,
  autoplay = false,
  playerId: playerIdProp,
}) => {
  const generatedId = useId().replace(/:/g, '');
  const playerId = playerIdProp ?? generatedId;

  useEffect(() => {
    const config: Record<string, unknown> = {
      id: playerId,
      height: '100%',
      width: '100%',
      autoplay,
      license: {
        domain: 'muyi.xinyixue.art',
        key: '7PnmvyKHlJNT4NmVx25ab1efbac8749bd8fd463eb450bfad6',
      },
    };

    if (disableFullscreen) {
      config.skinLayoutIgnore = ['controlBar.fullScreenButton'];
      config.dbClickFullscreen = false;
    }

    if (cryptoType === ECryptoType.HLS) {
      config.playConfig = { EncryptType: 'HLSEncryption' };
    }

    if (cryptoType === ECryptoType.Aliyun) {
      config.encryptType = 1;
    }

    if (cryptoType === ECryptoType.None) {
      config.format = 'mp4';
    }

    if (url) {
      config.source = url;
    }

    if (videoId && playAuth) {
      config.vid = videoId;
      config.playauth = playAuth;
    }

    const player = new Aliplayer(config);
    player.on('error', (error: unknown) => {
      console.error(error);
    });

    return () => {
      player.dispose();
    };
  }, [playerId, playAuth, videoId, url, cryptoType, disableFullscreen, autoplay]);

  return <div id={playerId} className="h-full w-full" />;
};
